import { asMultiStyleConfig } from '../../utils/theme';
import { getColor } from '../../theme-tools';
var parts = ['conatiner', 'menu'];
var baseStyle = _ref => {
  var {
    theme,
    menuZIndex
  } = _ref;
  return {
    container: {
      '.tqc-select': {
        '&--is-invalid .tqc-select__control': {
          borderColor: 'red.700',
          '&:hover': {
            borderColor: 'red.700'
          },
          _focusWithin: {
            boxShadow: "0 0 4px 1px ".concat(getColor(theme, 'red.700'))
          }
        }
      },
      '.tqc-select__control': {
        borderRadius: '10px',
        border: "1px solid ".concat(getColor(theme, 'grey.500')),
        '&--is-focused': {
          borderColor: getColor(theme, 'blue.400'),
          boxShadow: "0 0 4px 1px ".concat(getColor(theme, 'blue.300'))
        },
        '&--is-disabled': {
          borderColor: 'grey.400',
          bg: '#F0F0F0',
          '.tqc-select__placeholder': {
            color: 'grey.800'
          },
          '.tqc-select__indicators': {
            color: 'grey.800'
          }
        }
      },
      '.tqc-select__value-container': {
        p: '6px 16px'
      },
      '.tqc-select__placeholder': {
        fontSize: '16px',
        lineHeight: '1.5rem',
        letterSpacing: '-0.2px',
        color: 'black',
        m: 0
      },
      '.tqc-select__single-value': {
        fontSize: '1rem',
        lineHeight: '1.5rem',
        letterSpacing: '-0.2px',
        color: 'black',
        maxWidth: 'calc(100% - 2rem)'
      },
      '.tqc-select__indicators': {
        pr: '1rem',
        color: 'blue.600'
      },
      '.tqc-select__indicator-separator': {
        display: 'none'
      }
    },
    menu: {
      '.tqc-select__menu': {
        mt: '1px',
        zIndex: menuZIndex !== null && menuZIndex !== void 0 ? menuZIndex : 999
      },
      '.tqc-select__menu-list': {
        p: 0
      },
      '.tqc-select__group': {
        py: 0
      },
      '.tqc-select__group-heading': {
        py: '.625rem',
        px: '1rem',
        mb: 0,
        bg: 'grey.200',
        fontSize: '1rem',
        color: 'black',
        fontWeight: 'semibold',
        textTransform: 'none',
        borderBottom: '1px solid #E9E9E9'
      },
      '.tqc-select__option': {
        fontSize: '1rem',
        lineHeight: '1.5rem',
        letterSpacing: '-0.2px',
        color: 'black',
        padding: '10px 1rem',
        bg: 'white',
        borderBottom: '1px solid #E9E9E9',
        '&--is-focused': {
          bg: 'blue.1140'
        },
        '&:hover': {
          bg: 'blue.1140'
        },
        '&:active': {
          bg: 'blue.1140'
        },
        '&--is-selected': {
          bg: 'blue.100',
          '&:hover,&:active': {
            bg: 'blue.100'
          }
        },
        '&--is-disabled': {
          color: 'grey.500',
          bg: 'white',
          '&:hover': {
            bg: 'white'
          },
          '&:active': {
            bg: 'white'
          }
        }
      },
      '.tqc-select__option--is-disabled.tqc-select__option--is-focused': {
        bg: 'grey.100'
      }
    }
  };
};
export default asMultiStyleConfig({
  parts,
  baseStyle
});